import { defineStore, storeToRefs } from 'pinia';
import { useBaseProfileStore } from '@/shared/stores/BaseProfileStore';

export const useProfileStore = defineStore('profileStore', () => storeToRefs(useBaseProfileStore()));
